import { useTranslation } from "react-i18next";
import { FreyaContainer } from "../components/freyaContainer/FreyaContainer";
import { FreyaCard } from "../components/freyaCard/FreyaCard";
import { Paragraph } from "../components/typography/paragraph/Paragraph";
import Container from "@mui/material/Container";
import { ReactComponent as MobileQrIcon } from "../../../assets/MobileQrIcon.svg";
import { ReactComponent as ErrorIcon } from "../../../assets/ErrorIcon.svg";
import { scannedRecentlyStyles } from "./ScannnedRecently.styles";
import { useLocation } from "react-router-dom";
import { useFailedScanLogic } from "../hooks/useFailedScanLogic";

export const ScannedRecently = () => {
  const { t } = useTranslation("common");
  const { state } = useLocation();
  const { isLoading } = useFailedScanLogic(state);

  if (isLoading) {
    return <div />;
  }

  return (
    <FreyaContainer>
      <FreyaCard headingText={t("freya.scanYourQrCode.unableToPrintBadge")}>
        <Paragraph>{t("freya.scanYourQrCode.scanFailed.scannedRecently")}</Paragraph>
        <Container sx={scannedRecentlyStyles.iconContainer}>
          <MobileQrIcon style={scannedRecentlyStyles.mobileIcon} />
          <ErrorIcon style={scannedRecentlyStyles.errorIcon} />
        </Container>
      </FreyaCard>
    </FreyaContainer>
  );
};
